import React, { useState, useEffect } from 'react';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    window.scrollTo({ 
      top: document.documentElement.scrollHeight,
      behavior: 'smooth' 
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2">
      {isVisible && (
        <>
          <button
            onClick={scrollToTop}
            className="p-2 bg-brand-blue/20 rounded-full hover:bg-brand-blue/30 transition-colors duration-300 shadow-lg hover:shadow-xl border border-brand-blue/50"
            aria-label="Scroll to top"
          >
            <svg className="w-6 h-6 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </button>

          <button
            onClick={scrollToBottom}
            className="p-2 bg-brand-blue/20 rounded-full hover:bg-brand-blue/30 transition-colors duration-300 shadow-lg hover:shadow-xl border border-brand-blue/50"
            aria-label="Scroll to bottom"
          >
            <svg className="w-6 h-6 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </button>
        </>
      )}
    </div>
  );
};

export default ScrollToTop;
